var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTicket2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.189 4.98c-.25-.01-.5-.02-.77-.02h-7.7l1.07-1.06c.98-.99 2.06-1.9 3.31-1.9 1.26 0 2.34.91 3.32 1.9l.56.56c.14.13.21.31.21.5v.02z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.54 12.45v-.88c0-3.93-1.2-5.12-5.12-5.12H7.58c-3.92 0-5.12 1.2-5.12 5.12V12c0 .4.31.71.7.71.84 0 1.51.68 1.51 1.51S4 15.74 3.16 15.74c-.39 0-.7.31-.7.71v.43c0 3.93 1.2 5.12 5.12 5.12h8.83c3.92 0 5.12-1.2 5.12-5.12 0-.39-.31-.71-.7-.71a1.5 1.5 0 0 1-1.51-1.5c.01-.83.68-1.5 1.52-1.5.39 0 .7-.32.7-.72zm-11.43 7.12c-.39 0-.71-.32-.71-.71v-2.68c0-.39.32-.71.71-.71.39 0 .71.32.71.71v2.68c0 .39-.32.71-.71.71zm0-6.59c-.39 0-.71-.32-.71-.71V9.59c0-.39.32-.71.71-.71.39 0 .71.32.71.71v2.68c0 .39-.32.71-.71.71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTicket2);
export default __webpack_public_path__ + "static/media/vuesax-bold-ticket-2.b1f51a8b81c9ef66c1eb681d69a6885d.svg";
export { ForwardRef as ReactComponent };